/*
Use a dynamic import to get the analytics module in a way that doesn't block the page from loading.
*/
export default function dynamicAnalytics() {
    return import(/* webpackChunkName: "anvilAnalytics" */ "anvil-analytics").then(({analytics}) => {
        return analytics;
    }).catch(e => console.error("Analytics could not be imported." + e));
}
